export const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
